/* CANFOTO V67BS-R19 | Evidence intake & deduplicated obligations | READ ONLY */
(function(W){'use strict';
const VERSION='CANFOTO-NORA-R19-EVIDENCE-INTAKE-V1';
const BASE='CANFOTO_NORA_PANEL_EVIDENCE_GATE_V67BS_R18';
const clean=x=>typeof x==='string'?x.trim():'';
const isRecord=x=>x&&typeof x==='object'&&!Array.isArray(x);
const finite=x=>typeof x==='number'&&Number.isFinite(x);
const owner=x=>x==='manufacturer' || x==='measured' || x==='verified_internal';
function validate(entry, field){
 if(!isRecord(entry))return 'NOT_OBJECT';
 if(entry.field!==field)return 'FIELD_MISMATCH';
 if(!clean(entry.sourceRef))return 'MISSING_SOURCE_REF';
 if(!clean(entry.observedAt))return 'MISSING_DATE';
 if(!owner(entry.sourceKind))return 'INVALID_SOURCE_KIND';
 if(entry.value===null||entry.value===undefined||entry.value===''||entry.value==='UNKNOWN')return 'MISSING_VALUE';
 if(typeof entry.value==='number'&&!finite(entry.value))return 'INVALID_NUMBER';
 if(typeof entry.value==='object')return 'INVALID_VALUE_TYPE';
 if(/lux|illuminance|photometr/i.test(field)){
  if(!finite(entry.value)||entry.value<0)return 'INVALID_LUX';
  if(!finite(entry.distanceM)||entry.distanceM<=0)return 'MISSING_DISTANCE';
  if(!clean(entry.cctK)||!clean(entry.modifier)||!clean(entry.mode))return 'MISSING_MEASUREMENT_CONTEXT';
 }
 return null;
}
const keyFor=(x)=>[x.key,x.lane,x.handle,x.role].join('|');
async function audit(intake={}){
 if(!isRecord(intake))throw Error('HOLD_INVALID_INTAKE');
 const original=W[BASE];if(typeof original?.audit!=='function')throw Error('HOLD_R18_NOT_READY');
 const r=await original.audit();if(r.status!=='PASS_GATE_INTEGRITY_WITH_EVIDENCE_HOLD')throw Error('HOLD_R18_STATUS');
 const native=isRecord(intake.native)?intake.native:{};
 const product=isRecord(intake.product)?intake.product:{};
 const nativeTasks=r.gates.flatMap(g=>g.requiredFields.map(field=>({key:g.key,field,scope:'NATIVE'})));
 const roleTasks=r.roleCases.flatMap(c=>c.missingEvidence.map(field=>({key:c.key,lane:c.lane,handle:c.handle,sourceHandle:c.sourceHandle,role:c.role,field,scope:'PRODUCT_ROLE',intakeKey:keyFor(c)})));
 const units=new Map();for(const t of roleTasks){const k=[t.sourceHandle||t.handle,t.role,t.field].join('|');if(!units.has(k))units.set(k,{unitKey:k,sourceHandle:t.sourceHandle||t.handle,role:t.role,field:t.field,affected:[]});units.get(k).affected.push({key:t.key,lane:t.lane,handle:t.handle});}
 let accepted=0,rejected=0;const results=[];
 for(const t of nativeTasks){const item=native[t.key]?.[t.field];const err=item===undefined?'NOT_PROVIDED':validate(item,t.field);if(!err)accepted++;else if(item!==undefined)rejected++;results.push({...t,state:err?'HOLD':'EVIDENCE_PRESENT_UNCERTIFIED',issue:err||null});}
 for(const u of units.values()){
  const item=product[u.sourceHandle]?.[u.role]?.[u.field];const err=item===undefined?'NOT_PROVIDED':validate(item,u.field);
  if(!err)accepted++;else if(item!==undefined)rejected++;
  results.push({scope:'PRODUCT_ROLE',sourceHandle:u.sourceHandle,role:u.role,field:u.field,affected:u.affected,state:err?'HOLD':'EVIDENCE_PRESENT_UNCERTIFIED',issue:err||null});
 }
 const checks={r18Ready:true,nativeTaskCount:nativeTasks.length===24,roleCaseCount:r.roleCases.length===14,
  noMutations:true,noAutomaticCertification:true,nonEmptyUnitSet:units.size>0};
 return {task:'V67BS_R19_EVIDENCE_INTAKE',version:VERSION,mode:'READ_ONLY_SHADOW',checks,
 nativeTaskCount:nativeTasks.length,roleOccurrenceCount:roleTasks.length,deduplicatedRoleEvidenceUnits:units.size,
 intakeFieldsAccepted:accepted,intakeFieldsRejected:rejected,obligations:results,
 sourceParity:true,certification:'HOLD_PENDING_EXTERNAL_EVIDENCE_AND_TECHNICAL_REVIEW',
 photometryCertified:false,scoreMutation:false,rankMutation:false,fpCurveMutation:false,
 status:Object.values(checks).every(Boolean)?'PASS_INTAKE_SCHEMA_WITH_TECHNICAL_HOLD':'HOLD'};
}
W.CANFOTO_NORA_PANEL_EVIDENCE_INTAKE_V67BS_R19=Object.freeze({version:VERSION,audit,validate,scoreMutation:false,rankMutation:false,fpCurveMutation:false});
})(window);
